import timer from '@devices/settings/device_settings/timer.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellyplug',
	friendly_name: 'Plug NB',
	family: 'relay',
	isPM: true,
	is_nb: true,
	modes: {
		relay: {
			channels: 1,
			settings: [
				timer,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'power_on_default', component: 'power_on_default_plug_s' },
						{ title: 'led_status_disable', component: 'led_status_disable' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
